import React, { Component, useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
// import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime,formatDate} from '../../Constants/Constants';
import { NavLink } from 'react-router-dom';

const CompanyUserCreate = () => {
    const { apiURL, apiHeaderFile, apiHeaderJson } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [createUser, setCreateUser] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingPost, setLoadingPost] = useState(false);
    const [formData, setFormData] = useState({
        companyId: "",
        company_user_id: "",
        company_user_name: "",
        company_user_email: "",
        company_user_login_id: "",
        company_user_login_password: "",
        headerPath: "",
        headerStatus: "0",
        parentId: null,
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});

    const getList = () => {
        const headers = apiHeaderJson;
        axios.get(`${apiURL}CompanyMasters/GetCompanyAdminList`, {
            params: {
                company_id: formData?.companyId
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log("GetCompanyAdminList =>",data);
            if (response.data.success === true) {
                let rows = data?.header_list?.map((val) => {
                    return { value: val?.module_id, label: val?.header_name }
                });
                setParentHeaderRows(rows);  
                setRows(data?.data);
            } else {
                setParentHeaderRows([]);
                setRows([]);
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    const getCompanies = () => {
        const headers = apiHeaderJson;
        console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/getCompanies`, {
            params: {
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log("getCompanies",data);
            if (response.data.success === true) {
                let rows = data?.companies?.map((val,idx) => {
                    return  { value: val?.company_id, label: val?.company_name }
                });
                setCompanyOptions(rows);
                
            } else {
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        if (isChanged) {
            getList();
            setIsChanged(false);
        }
    }, [isChanged]);

    useEffect(() => {
        getCompanies();
    }, []);

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleToggleSwitch = (company_user_id, toggleButton) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    company_id: formData?.companyId,
                    company_user_id: company_user_id,
                    activated: toggleButton ? "1" : "0",
                    date: currentDateAndTime(),
                }
                const headers = apiHeaderJson;
                // setToggleButton(!toggleButton);
                console.log(data);
                axios
                    .post(`${apiURL}CompanyMasters/HandleCompanyAdminAction`, data, {headers,})
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                            
                            getList();
                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }

    const getInfo = (row) => {
        // const headers = apiHeaderJson;
        // axios.get(`${apiURL}CompanyMasters/GetHeaderInfo`,
        //     {
        //         params: {
        //             moduleId: id
        //         },
        //         headers
        //     }).then((response) => {
        //         const { success, result } = response.data;
        //         console.log(response?.data);
        //         if (success === true) {
        //             setFormData({
        //                 ...formData,
        //                 module_id: result[0]?.module_id,
        //                 headerName: result[0]?.header_name,
        //                 headerPath: result[0]?.header_path,
        //                 // headerStatus: result[0]?.header_status || "0",
        //                 parentId: result[0]?.parent_id,
        //             });

        //         } else {

        //         }
        //     });
        setFormData({
            ...formData,
            companyId: row?.company_id,
            company_user_id: row?.company_user_id,
            company_user_name: row?.company_user_name,
            company_user_email: row?.company_user_email,
            company_user_login_id: row?.company_user_login_id,
            company_user_login_password: row?.company_user_login_password,
        })
        setCreateUser(true);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // const errors = validateForm();
        // console.log("errors 1", errors);
        // if (Object.keys(errors).length > 0) {
        //     setErrors(errors);
        //     return;
        // }
        setLoadingPost(true);
        let data = {
            company_user_id: formData?.company_user_id || null,
            company_id: formData?.companyId,
            company_user_name: formData?.company_user_name,
            company_user_email: formData?.company_user_email,
            company_user_login_id: formData?.company_user_login_id,
            company_user_login_password: formData?.company_user_login_password,
            date: currentDateAndTime(),

        }
        setLoadingPost(true);
        const headers = apiHeaderJson;
        // console.log("formData?.companyId", formData?.companyId);
        // console.log("handleSubmit ~ form Data =======>>>", formData);
        axios
            .post(`${apiURL}CompanyMasters/CreateUpdateCompanyAdmin`, data, {
                params: {
                    user_id: localStorage?.getItem("user_id_master"),
                    companyId: formData?.companyId
                },
                headers,
            })
            .then((response) => {
                const { success, } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    });
                    setCreateUser(false);
                    setFormData({
                        companyId: formData?.companyId,
                        company_user_id: "",
                        company_user_name: "",
                        company_user_email: "",
                        company_user_login_id: "",
                        company_user_login_password: "",
                        headerPath: "",
                        headerStatus: "0",
                        parentId: "",
                    });
                    getList();
                    setLoadingPost(false);
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    setLoadingPost(false);

                }
            }).catch((error)=>{
                console.log(error);
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: "Opps..!! Something went wrong.",
                    icon: 'error',
                    showConfirmButton: true, 
                    allowOutsideClick:false
                });
            }).finally(setLoadingPost(true));

    };
    const [expandedRows, setExpandedRows] = useState({});
    const [data, setData]= useState([
        {
            "name": "Dashboard",
            "path": "/"
        },
        {
            "name": "Employee Management",
            "path": "",
            "sub_module": [
                {
                    "name": "Employee Onboarding Life Cycle",
                    "path": "",
                    "sub_module": [
                        {
                            "name": "Offer Letter Form",
                            "path": "GuestEmployee"
                        },
                        {
                            "name": "Sent Offers List",
                            "path": "OfferLetterSentList"
                        },
                        {
                            "name": "Candidate Information Collection",
                            "path": "CandidateInfoCollection"
                        },
                        {
                            "name": "Sent Appointment Letter",
                            "path": "SentAppointmentLetter"
                        },
                        {
                            "name": "Induction Process",
                            "path": "InductionProcess"
                        }
                    ]
                },
                {
                    "name": "Employee Onboarding (Excel)",
                    "path": "EmployeeOnboarding"
                },
                {
                    "name": "Employees Life Cycle",
                    "path": "",
                    "sub_module": [
                        {
                            "name": "Assign Shift",
                            "path": "AssignShiftes"
                        },
                        {
                            "name": "Assign RM",
                            "path": "AssignRM"
                        },
                        {
                            "name": "Employee Master",
                            "path": "CandidateDetailsList"
                        }
                    ]
                },
                {
                    "name": "PMS",
                    "path": "",
                    "sub_module": [
                        {
                            "name": "Employee Goals Report",
                            "path": "EmployeeGoalsReport"
                        }
                    ]
                }
            ]
        },
        {
            "name": "Letter Management",
            "path": "",
            "sub_module": [
                {
                    "name": "Letter Head Master",
                    "path": "LetterHeadList"
                },
                {
                    "name": "Letter Template Master",
                    "path": "LetterList"
                },
                {
                    "name": "Email Master",
                    "path": "EmailTemplateList"
                }
            ]
        },])
        // const ToggleSwitch = ({ isActive, onToggle }) => (
        //     <label className="switch">
        //         <input
        //             type="checkbox"
        //             checked={isActive}
        //             onChange={onToggle}
        //         />
        //         <span className="slider round"></span>
        //     </label>
        // );
        
        const [moduleData, setModuleData] = useState(data);
        // const [expandedRows, setExpandedRows] = useState({});
    
        const toggleRow = (moduleName) => {
            setExpandedRows((prev) => ({
                ...prev,
                [moduleName]: !prev[moduleName],
            }));
        };
    
        const updateStatusRecursively = (modules, newStatus) => {
            return modules.map((module) => ({
                ...module,
                header_status: newStatus,
                sub_module: module.sub_module
                    ? updateStatusRecursively(module.sub_module, newStatus)
                    : undefined,
            }));
        };
    
    const handleToggle = (moduleName, newStatus, parentModules) => {
        const updatedModules = (modules) =>
            modules.map((module) => {
                if (module.name === moduleName) {
                    return {
                        ...module,
                        header_status: newStatus,
                        sub_module: module.sub_module
                            ? updateStatusRecursively(module.sub_module, newStatus)
                            : undefined,
                    };
                }
                return {
                    ...module,
                    sub_module: module.sub_module
                        ? updatedModules(module.sub_module)
                        : undefined,
                };
            });
    
        setModuleData((prev) => updatedModules(prev));
    };
    const renderRows = (modules, parentName = null, level = 0) => {
        return modules.map((module) => (
            <React.Fragment key={module.name}>
                <tr>
                    <td style={{ paddingLeft: `${level * 20}px` }}>
                        <div className=' ps-2 d-flex align-items-center'>
                        
                            <button
                            // disabled={!module.sub_module}
                            // ${!module.sub_module? "light":"primary" }
                                className={`btn btn-xs py-0 px-0 ${!module.sub_module? "ms-2 me-2":"me-1"} `}
                                onClick={() => {if(module.sub_module) console.log("clicked"); toggleRow(module.name);}}
                            >
                                <i className={` text-${!module.sub_module? "dark":"primary" } ${!module.sub_module? "ri-checkbox-blank-circle-fill fs-12" : expandedRows[module.name] ? "ri-arrow-down-s-fill  fs-24" : "ri-arrow-right-s-fill  fs-24"} label-icon cursorPointer align-middle`} />
                                {/* {expandedRows[module.name] ? '-' : '+'} */}
                            </button>
                            {module.name}
                        </div>
                    </td>
                    <td>{parentName || '--'}</td>
                    <td>
                        <ToggleSwitch
                            isActive={module?.header_status === '1'}
                            isExtFunc={true}
                            onToggle={() =>
                                handleToggle(module.name, module.header_status === '1' ? '0' : '1')
                            }
                        />
                    </td>
                    {/* <td>
                        <button
                            type="button"
                            className="btn-icon btn btn-sm btn-outline-primary"
                            onClick={() => {
                                console.log(`Edit ${module.name}`);
                            }}
                        >
                            <i className="ri-edit-box-line"></i>
                        </button>
                    </td> */}
                </tr>
                {expandedRows[module.name] &&
                    module.sub_module &&
                    renderRows(module.sub_module, module.name, level + 1)}
            </React.Fragment>
        ));
    };

    const data2 = [
        {
          header_id:1,
          name: "Dashboard",
          path: "/",
          selected: true
        },
        {
            header_id:2,
          name: "Employee Management",
          path: "",
          sub_module: [
            {
                header_id:3,
              name: "Employee Onboarding Life Cycle",
              path: "",
              selected: true,
              sub_module: [
                { header_id:4,name: "Offer Letter Form", path: "GuestEmployee" },
                { header_id:5,name: "Sent Offers List", path: "OfferLetterSentList",selected: true },
                { header_id:6,name: "Candidate Information Collection", path: "CandidateInfoCollection" },
                { header_id:7,name: "Sent Appointment Letter", path: "SentAppointmentLetter" },
                { header_id:8,name: "Induction Process", path: "InductionProcess",selected: true },
              ],
            },
            {
                header_id:9,
              name: "Employee Onboarding (Excel)",
              path: "EmployeeOnboarding",
            },
            {
                header_id:10,
              name: "Employees Life Cycle",
              path: "",
              sub_module: [
                { header_id:11,name: "Assign Shift", path: "AssignShiftes" },
                { header_id:12,name: "Assign RM", path: "AssignRM" },
                { header_id:13,name: "Employee Master", path: "CandidateDetailsList" },
              ],
            },
          ],
        },
      ];
    const [menu, setMenu] = useState(data2);

    const handleSelectionChange = (updatedMenu) => {
        setMenu([...updatedMenu]);
    };
    useEffect(()=>{
        console.log(menu);
    },[menu])
    const MenuTree = ({ menu, selected, onChange }) => {
        // Handle change for parent and child
        const handleChange = (menuItem, isChecked) => {
          const updateSelection = (item, isSelected) => {
            item.selected = isSelected;
            if (item.sub_module) {
              item.sub_module.forEach((child) => updateSelection(child, isSelected));
            }
          };
          updateSelection(menuItem, isChecked);
          onChange([...selected]);
        };
      
        // Render a menu item and its children recursively
        const renderMenu = (menuItem) => (
          <div key={menuItem.name} style={{ marginLeft: "20px" }}>
            <label>
              <input
                type="checkbox"
                checked={menuItem.selected || false}
                onChange={(e) => handleChange(menuItem, e.target.checked)}
              />
              {menuItem.name}
            </label>
            {menuItem.sub_module &&
              menuItem.sub_module.map((child) => renderMenu(child))}
          </div>
        );
      
        return <>{menu.map(renderMenu)}</>;
      };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Company User Master`} primary={`Home`} />
                    <div className="card">
                        <div className='card-header align-items-center justify-content-between d-flex'>
                            <div style={{ width:"23rem", height:"2rem"}} className=''>
                                <div className=' position-relative'>
                                    {/* <div>
                                        <label>Company</label>
                                    </div> */}
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <Select
                                        onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, companyId: selectedOption?.value }) }}
                                        placeholder={`Select Company`}
                                        options={companyOptions}
                                        value={formData?.companyId ? companyOptions.find(option => option.value == formData?.companyId) : null}
                                        />
                                    </div>
                                </div>
                            </div>
                           

                            <button type="button" disabled={!formData?.companyId} className="btn btn-primary"
                            onClick={()=>{
                                setFormData({
                                    ...formData,
                                    company_user_id: "",
                                    company_user_name: "",
                                    company_user_email: "",
                                    company_user_login_id: "",
                                    company_user_login_password: "",
                                });
                                setCreateUser(true);}} >
                            <i className="ri-menu-add-fill" />
                            Create User
                            </button>
                        </div>
                        {createUser && (
                        <div className="modal show" 
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                            }} >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalgridLabel">{formData.company_user_id? "Update" : "Create"} user</h5>
                                    <button type="button"
                                    disabled={loadingPost} className="btn-close" onClick={()=>{
                                        setFormData({
                                            ...formData,
                                            company_user_id: "",
                                            company_user_name: "",
                                            company_user_email: "",
                                            company_user_login_id: "",
                                            company_user_login_password: "",
                                        });
                                        setCreateUser(false);
                                    }} aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                    <div className="container mt-2">
                                    <form onSubmit={handleSubmit} className="row">
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="company_user_name" className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                id="company_user_name"
                                                name="company_user_name"
                                                value={formData?.company_user_name}
                                                onChange={(e) => handleChange("company_user_name", e.target.value)}
                                                placeholder="Enter Name"
                                            />
                                            {errors.company_user_name && <div className="text-danger">{errors.company_user_name}</div>}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="company_user_email" className="form-label">Email</label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                id="company_user_email"
                                                name="company_user_email"
                                                value={formData?.company_user_email}
                                                onChange={(e) => handleChange("company_user_email", e.target.value)}
                                                placeholder="Enter Email"
                                            />
                                            {errors.company_user_email && <div className="text-danger">{errors.company_user_email}</div>}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="company_user_login_id" className="form-label">User Login Id</label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.company_user_login_id ? 'is-invalid' : ''}`}
                                                id="company_user_login_id"
                                                name="company_user_login_id"
                                                value={formData?.company_user_login_id}
                                                onChange={(e) => handleChange("company_user_login_id", e.target.value)}
                                                placeholder="Enter Login id"
                                            />
                                            {errors.company_user_login_id && <div className="text-danger">{errors.company_user_login_id}</div>}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="company_user_login_password" className="form-label">User login Password</label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.company_user_login_password ? 'is-invalid' : ''}`}
                                                id="company_user_login_password"
                                                name="company_user_login_password"
                                                value={formData?.company_user_login_password}
                                                onChange={(e) => handleChange("company_user_login_password", e.target.value)}
                                                placeholder="Enter Password"
                                            />
                                            {errors.company_user_login_password && <div className="text-danger">{errors.company_user_login_password}</div>}
                                        </div>
                                        <div className="col-md-12" style={{ marginTop: "30px" }}>
                                            {/* <button
                                                disabled={!formData?.company_user_name || !formData?.company_user_email || !formData?.company_user_login_id || !formData?.company_user_login_password || loadingPost}
                                                type="submit"
                                                className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                            >
                                                <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                {!loadingPost? formData?.module_id ? "Update" : "Save" : "Loading..."}
                                            </button> */}
                                            {!loadingPost ?
                                                    <button
                                                    disabled={!formData?.company_user_name || !formData?.company_user_email || !formData?.company_user_login_id || !formData?.company_user_login_password || loadingPost}
                                                    className={`btn noWrap btn-primary btn-label waves-effect right waves-light `}
                                                    type="submit"
                                                    >
                                                        <i className={`ri-save-line label-icon align-middle fs-16`} /> {!loadingPost ? formData?.company_user_id?"Update":"Save" : "Processing..."}</button> :
                                                    <button className="btn btn-primary btn-load">
                                                        <span className="d-flex align-items-center">
                                                            <span className="spinner-border flex-shrink-0" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </span>
                                                            <span className="flex-grow-1 ms-2">
                                                                Processing...
                                                            </span>
                                                        </span>
                                                    </button>
                                                }
                                        </div>
                                    </form>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        )}
                        <div className=' row card-body'>
                            {/* <div className="col-md-5">
                                <div style={{"minHeight": "65vh"}} className="card">
                                
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">{formData?.module_id ? "Update" : "Create"} Navigation Header</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={handleSubmit} className="row">
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="company_user_name" className="form-label">Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                            id="company_user_name"
                                                            name="company_user_name"
                                                            value={formData?.name}
                                                            onChange={(e) => handleChange("company_user_name", e.target.value)}
                                                            placeholder="Enter Name"
                                                        />
                                                        {errors.company_user_name && <div className="text-danger">{errors.company_user_name}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="company_user_email" className="form-label">Email</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                            id="company_user_email"
                                                            name="company_user_email"
                                                            value={formData?.company_user_email}
                                                            onChange={(e) => handleChange("company_user_email", e.target.value)}
                                                            placeholder="Enter Email"
                                                        />
                                                        {errors.company_user_email && <div className="text-danger">{errors.company_user_email}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="company_user_login_id" className="form-label">User Login Id</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.company_user_login_id ? 'is-invalid' : ''}`}
                                                            id="company_user_login_id"
                                                            name="company_user_login_id"
                                                            value={formData?.company_user_login_id}
                                                            onChange={(e) => handleChange("company_user_login_id", e.target.value)}
                                                            placeholder="Enter Header Name"
                                                        />
                                                        {errors.company_user_login_id && <div className="text-danger">{errors.company_user_login_id}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="company_user_login_password" className="form-label">User login Password</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.company_user_login_password ? 'is-invalid' : ''}`}
                                                            id="company_user_login_password"
                                                            name="company_user_login_password"
                                                            value={formData?.company_user_login_password}
                                                            onChange={(e) => handleChange("company_user_login_password", e.target.value)}
                                                            placeholder="Enter Header Name"
                                                        />
                                                        {errors.company_user_login_password && <div className="text-danger">{errors.company_user_login_password}</div>}
                                                    </div>
                                                    
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        <button
                                                            disabled={!formData?.company_user_name || !formData?.company_user_email || !formData?.company_user_login_id || !formData?.company_user_login_password || loadingPost}
                                                            type="submit"
                                                            className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                        >
                                                            <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                            {!loadingPost? formData?.module_id ? "Update" : "Save" : "Loading..."}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-md-12">
                                <div className='card'>
                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="  col-md-12">
                                        <table className={`position-relative table table-bordered table-stripped `}>
                                            <thead className='table-light sticky-top z-1'>
                                                <tr>
                                                    <th style={{ width:"10%"}}>Date</th>
                                                    <th style={{ width:"20%"}}>Name</th>
                                                    <th style={{ width:"20%"}}>Email</th>
                                                    <th style={{ width:"15%"}}>User Id</th>
                                                    <th style={{ width:"15%"}}>Password</th>
                                                    <th style={{ width:"10%"}} className=' text-center'>Status</th>
                                                    <th style={{ width:"10%"}} className=' text-center'>Action</th>
                                                </tr>
                                            </thead>
                                            {rows?.length === 0 ?
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={8}>
                                                            <NoRecords />
                                                        </td>
                                                    </tr>
                                                </tbody> :
                                                <tbody>
                                                    {
                                                        rows?.map((row) => {
                                                            return <tr key={row.company_user_id}>
                                                                <td>{row?.updated_date? formatDate(row?.updated_date) : "--"}</td>
                                                                <td>{row.company_user_name || "--"}</td>
                                                                <td>{row.company_user_email || "--"}</td>
                                                                <td>{row.company_user_login_id || "--"}</td>
                                                                <td>
                                                                    <div className=' d-flex align-items-center'>
                                                                        <div style={{ width:"90%"}} className={`${showPassword === row?.company_user_id? "text-primary":""}`}>
                                                                             {showPassword === row?.company_user_id?
                                                                             (row.company_user_login_password || "--"):
                                                                             ("••••••••")}
                                                                        </div>
                                                                        <div style={{ width:"10%"}} >
                                                                            {showPassword === row?.company_user_id?
                                                                            (
                                                                                <i onClick={()=>{ setShowPassword(false) }} className={` ri-eye-line label-icon cursorPointer text-primary align-middle fs-16`} />
                                                                            ):
                                                                            (
                                                                                <i onClick={()=>{ setShowPassword(row?.company_user_id) }} className={` ri-eye-off-line label-icon cursorPointer align-middle fs-16`} />
                                                                            )}
                                                                            
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className=' text-center'>
                                                                    {/* {row?.header_status == '1' ? <span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-success text-white'>On</span>:<span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-warning text-white'>Off</span> } */}
                                                                    <ToggleSwitch isActive={row?.company_user_status == '1'} isExtFunc={true} onToggle={() => { handleToggleSwitch(row?.company_user_id,row?.company_user_status == "1" ? false : true) }} />
                                                                </td> 
                                                                <td className='d-flex justify-content-around'>
                                                                    <button type='button' onClick={() => {  getInfo(row) }} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                    {/* <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                                                    {/* <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button> */}
                                                                </td>
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            }

                                        </table>
                                    </div>
                                </div>

                            </div>
                            {/* <div className="col-md-12">
                                <div className="card">
                                    <div style={{ maxHeight: '65vh', overflowY: 'auto' }} className="col-md-12">
                                        <table className="position-relative table table-bordered table-stripped">
                                            <thead className="table-light sticky-top z-1">
                                                <tr>
                                                    <th>Module Name</th>
                                                    <th>Parent Name</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {moduleData.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={4}>
                                                            <div>No Records Found</div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    renderRows(moduleData)
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="card">
                                    <div>
                                        <h1>Menu</h1>
                                        <MenuTree menu={menu} selected={menu} onChange={handleSelectionChange} />
                                        <button
                                            onClick={() =>
                                            console.log(
                                                "Selected Items:",
                                                JSON.stringify(menu, null, 2)
                                            )
                                            }
                                        >
                                            Log Selected Items
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyUserCreate;
